import { Flex } from '@chakra-ui/react';
import { useAppSelector } from 'Hooks';
import React from 'react';
import { FooterSection } from './FooterSection';
import { HeaderSection } from './HeaderSection';
import { useIsNewSurvey } from 'Utils/surveyUtils';

interface ISurveyContainerProps {
	children: React.ReactNode;
}

export const SurveyContainer = ({ children }: ISurveyContainerProps) => {
	const {
		hasStartedSurvey,
		activeSurvey: { survey },
	} = useAppSelector((state) => state.survey);

	const isNewSurvey = useIsNewSurvey();
	
	// If survey is gone (closed), render nothing to avoid showing header/footer
	if (!survey) {
		return null;
	}

	return (
		<Flex direction='column' h='100dvh'>
			<HeaderSection />
			{/* Add padding-top to account for fixed header: 60px mobile + 20px spacing, 118px desktop + 20px spacing */}
			<Flex direction='column' pt={['80px', '138px']} alignItems='center' flex={1} overflowY='auto'>
				{children}
			</Flex>
			{(!isNewSurvey || hasStartedSurvey) && <FooterSection />}
		</Flex>
	);
};
